module.exports = __webpack_public_path__ + "img/tuin_icon.04689f9a.png";